// assets
import {
  IconAdjustments,
  IconBook,
  IconCoin,
  IconDashboard,
  IconKey,
  IconLogs,
  IconRobot,
  IconShare2,
  IconSitemap,
  IconUser,
  IconUserScan,
} from "@tabler/icons-react";

// constant
const icons = {
  IconDashboard,
  IconSitemap,
  IconBook,
  IconCoin,
  IconAdjustments,
  IconKey,
  IconUser,
  IconUserScan,
  IconLogs,
  IconShare2,
  IconRobot,
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const panel = [
  {
    id: "panel",
    type: "group",
    children: [
      {
        id: "dashboard",
        title: "总览",
        type: "item",
        url: "/panel/dashboard",
        icon: icons.IconDashboard,
        breadcrumbs: false,
        isAdmin: false,
      },
      {
        id: "analytic",
        title: "分析",
        type: "item",
        url: "/panel/analytic",
        icon: icons.IconCoin,
        breadcrumbs: false,
        isAdmin: false,
      },
      // {
      //   id: "model",
      //   title: "模型",
      //   type: "item",
      //   url: "/panel/model",
      //   icon: icons.IconRobot,
      //   breadcrumbs: false,
      //   isAdmin: false,
      // },
      {
        id: "channel",
        title: "渠道",
        type: "item",
        url: "/panel/channel",
        icon: icons.IconSitemap,
        breadcrumbs: false,
        isAdmin: true,
      },
      {
        id: "token",
        title: "令牌",
        type: "item",
        url: "/panel/token",
        icon: icons.IconKey,
        breadcrumbs: false,
      },
      {
        id: "log",
        title: "日志",
        type: "item",
        url: "/panel/log",
        icon: icons.IconLogs,
        breadcrumbs: false,
      },
      {
        id: "redemption",
        title: "兑换",
        type: "item",
        url: "/panel/redemption",
        icon: icons.IconCoin,
        breadcrumbs: false,
        isAdmin: true,
      },
      {
        id: "user",
        title: "用户",
        type: "item",
        url: "/panel/user",
        icon: icons.IconUser,
        breadcrumbs: false,
        isAdmin: true,
      },

      {
        id: "setting",
        title: "设置",
        type: "item",
        url: "/panel/setting",
        icon: icons.IconAdjustments,
        breadcrumbs: false,
        isAdmin: true,
      },
    ],
  },
  {
    id: "setting",
    type: "group",
    children: [
      {
        id: "document",
        title: "文档",
        type: "item",
        url: "https://s.apifox.cn/f6ae450b-3c34-4aca-99eb-8bbe25bb59c5",
        icon: icons.IconBook,
        breadcrumbs: false,
        isAdmin: false,
        afterIcon: icons.IconShare2,
        external: true,
        target: "_blank",
      },
      {
        id: "profile",
        title: "我的",
        type: "item",
        url: "/panel/profile",
        icon: icons.IconUserScan,
        breadcrumbs: false,
        isAdmin: false,
      },
    ],
  },
];

export default panel;
